import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/City");
}

const GetForUser = () => {
  return apiClient
    .get("/City/GetForUser");
}
const SoftDelete = (id) => {
  return apiClient
    .delete("/City/SoftDelete", {
      params: {
        'Id': id,
        'delete': true
      }
    });
}

const Add = (data) => {
  return apiClient.post('/City', {
    'name': data.cityName
  }
  )
}
const Update = (id, data) => {
  return apiClient.put('/City', {
    'id': id,
    'name': data.cityName,
    'isActive': data.isActive
  }
  )
}

const cityApi = {
  Add, Update, GetAll, GetForUser, SoftDelete
}

export default cityApi